import { NgModule } from '@angular/core';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { DefaultFooterComponent, DefaultHeaderComponent } from './components';
import { DefaultLayoutComponent } from './layouts';
import { SharedModule } from '../shared';
import {
  HomeComponent, RegisterComponent,
  ResetPasswordRequestComponent,

  SignInComponent,
  PrivacyPolicyComponent, TermsAndConditionsComponent,
  /*SPResetPasswordComponent, */ ResetPasswordComponent
} from './pages';
import { ROUTES } from './public.routes';
const PROVIDERS = [
];
import { JoinModule } from './join';

@NgModule({ declarations: [
  DefaultFooterComponent,
  DefaultHeaderComponent,
  DefaultLayoutComponent,
  HomeComponent,
  RegisterComponent,
  ResetPasswordRequestComponent,
  ResetPasswordComponent,
  SignInComponent,
  PrivacyPolicyComponent,
  TermsAndConditionsComponent /*,
        SPResetPasswordComponent*/
], imports: [SharedModule,
  RouterModule.forChild(ROUTES),
  FormsModule,
  ReactiveFormsModule,
  CommonModule,
  JoinModule], providers: [
  PROVIDERS,
  provideHttpClient(withInterceptorsFromDi())
] })
export class PublicModule { }
